
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50.5 50.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".5"}},[_c('path',{attrs:{"d":"M50.25 2.75a2.5 2.5 0 00-2.5-2.5h-45a2.5 2.5 0 00-2.5 2.5v45a2.5 2.5 0 002.5 2.5h45a2.5 2.5 0 002.5-2.5z"}}),_c('path',{attrs:{"d":"M44.013 40.244l-6.629-17.686a1.246 1.246 0 00-2.206-.25l-8.63 12.945-5.112-6.135a1.244 1.244 0 00-2.028.158l-6.582 10.967M16.497 17.738a3.742 3.742 0 10-3.742-3.742 3.743 3.743 0 003.742 3.742zM50.25 40.27h-50"}})])])
          )
        }
      }
    